import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c929d51a")

_pushScopeId("data-v-c929d51a")
const _hoisted_1 = {
  class: "datepicker__calendar top-auto absolute",
  style: { top: 100, left: `0` },
  ref: "popupCalendar"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Input = _resolveComponent("Input")
  const _component_CalendarDay = _resolveComponent("CalendarDay")
  const _directive_click_outside = _resolveDirective("click-outside")

  return _withDirectives((_openBlock(), _createBlock("div", {
    style: { width: _ctx.width + 'px' },
    class: "relative"
  }, [
    _createVNode("div", {
      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
      ref: "calendar",
      class: _ctx.disabled ? 'pointer-events-none' : ''
    }, [
      _createVNode(_component_Input, {
        disabled: _ctx.disabled,
        placeholder: _ctx.placeholder,
        modelValue: _ctx.date,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.date = $event)),
        onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeInput($event))),
        iconPrepend: "cp-icon-calendar",
        "error-server": _ctx.errorServer,
        required: _ctx.required,
        validated: _ctx.validated,
        errors: _ctx.errorMessage,
        "onUpdate:errors": _cache[3] || (_cache[3] = ($event: any) => (_ctx.errorMessage = $event))
      }, null, 8, ["disabled", "placeholder", "modelValue", "error-server", "required", "validated", "errors"])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode(_component_CalendarDay, {
        date: _ctx.date,
        "onUpdate:date": _cache[5] || (_cache[5] = ($event: any) => (_ctx.date = $event)),
        isShowCalendar: _ctx.isShowCalendar,
        "onUpdate:isShowCalendar": _cache[6] || (_cache[6] = ($event: any) => (_ctx.isShowCalendar = $event)),
        format: _ctx.format
      }, null, 8, ["date", "isShowCalendar", "format"])
    ], 512), [
      [_vShow, _ctx.isShowCalendar]
    ])
  ], 4)), [
    [_directive_click_outside, _ctx.closeCalendar]
  ])
})